import { useRequest, useTitle } from 'ahooks'
import { Button, Form, PageHeader } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { routes } from '@/router'
import { ProjectType } from '@/schemas'

import { ProjectForm } from './project-form.component'

export const ProjectCreateContainer = () => {
  const { t } = useTranslation()
  const [form] = Form.useForm()
  const history = useHistory()

  useTitle(t('project.create'), { restoreOnUnmount: true })

  React.useEffect(() => {
    form.setFieldsValue({
      projectType: ProjectType.DEFAULT,
    })
  }, [])

  const { loading, run } = useRequest(
    (data) => ({
      url: '/api/project/createProject',
      method: 'post',
      data,
    }),
    {
      manual: true,
      onSuccess: (data) => {
        history.push(routes.project.page(data.selfId))
      },
    }
  )

  return (
    <>
      <PageHeader title={t('project.create')} onBack={() => history.goBack()} />
      <div className='py-8px px-32px'>
        <ProjectForm form={form} onSubmit={run}>
          <Button type='primary' htmlType='submit' loading={loading}>
            {t('project.create')}
          </Button>
        </ProjectForm>
      </div>
    </>
  )
}
